import Impressum from "./Impressum";
import Produktion from "./Produktion";
import Releases from "./Releases/Releases";
import logo from "./assets/rt_logo.png";

interface MainProps {
  width: number;
  isMobile: boolean;
}

const Main: React.FC<MainProps> = ({ width, isMobile }) => {
  return (
    <div className="logo">
      <img className="responsive-img" src={logo} alt="regentaenzer" />
      
      <h2>About</h2>
      Indie-Label aus München. <b><i>Regentänzer</i></b> tanzen euphorisch und
      melancholisch. Hier gibt's Musik für gute und schlechte Tage und vor allem
      für alles zwischendrin. Nachdenkliche Songs werden besonders laut
      aufgedreht.
      
      <br />
      <br />

      <h2>Releases</h2>
      <Releases />
      <br />

      <Produktion />

      <br />

      <h2>Kontakt</h2>
      <p>
        Alle Anfragen:{" "}
        <a href="mailto:label@regentaenzer.com">label@regentaenzer.com</a>
      </p>

      <Impressum />
    </div>
  );
};

export default Main;
